/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Clients API
 * AV Services Clients management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  Dashboard,
  DashboardDto,
  DashboardsControllerCreateV1PathParameters,
  DashboardsControllerDeleteV1PathParameters,
  DashboardsControllerDetailsV1PathParameters,
  DashboardsControllerListV1200,
  DashboardsControllerListV1PathParameters,
  DashboardsControllerUpdateV1PathParameters,
} from '../models';

@Injectable({ providedIn: 'root' })
export class DashboardsService {
  private readonly http = inject(HttpClient);
  /**
   * Creates a dashboard for the client
   */

  create<TData = Dashboard>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: DashboardsControllerCreateV1PathParameters,
    dashboardDto: DashboardDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/clients/v1/${clientId}/dashboards`, dashboardDto);
  }
  /**
   * Retrieves a list of dashboards of the client
   */

  list<TData = DashboardsControllerListV1200>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
  }: DashboardsControllerListV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/clients/v1/${clientId}/dashboards`);
  }
  /**
   * Deletes the dashboard from the client
   */

  delete<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    dashboardId,
  }: DashboardsControllerDeleteV1PathParameters): Observable<TData> {
    return this.http.delete<TData>(`/clients/v1/${clientId}/dashboards/${dashboardId}`);
  }
  /**
   * Gets the dashboard of the client
   */

  details<TData = Dashboard>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    dashboardId,
  }: DashboardsControllerDetailsV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/clients/v1/${clientId}/dashboards/${dashboardId}`);
  }
  /**
   * Updates the dashboard of the client
   */

  update<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, dashboardId }: DashboardsControllerUpdateV1PathParameters,
    dashboardDto: DashboardDto,
  ): Observable<TData> {
    return this.http.put<TData>(`/clients/v1/${clientId}/dashboards/${dashboardId}`, dashboardDto);
  }
}
